export const state = {
  list: []
}
